<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-info-card :title="title" color="primary">
        <slot></slot>
      </base-info-card>

      <template v-for="({ icon, text, title: t }, i) in business">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div v-html="text"></div>
        </base-avatar-card>

        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-2"
        />
      </template>
      <div>
        <a href="https://g.page/r/CVlqWde4jdUhEBI/review" target="_blank">
          <base-img
            :src="require('@/assets/Google.webp')"
            contain
            max-width="250"
            min-height="78"
            width="100%"
            class="logo-filter"
          />
        </a>
      </div>
      <div>
        <v-divider
          v-if="i + 1 !== business.length"
          :key="`divider-${i}`"
          class="my-6"
        />
      </div>
      <div>
        <base-info-card title="Special Promotion">
          <a
            class="mb-5 grey--text body-1 d-block text-none"
            href="/promotions"
            target=""
            >&rsaquo; Startup Promotion</a
          >

          <a
            class="mb-5 grey--text body-1 d-block text-none"
            href="/maid-agency-accounting-promotion"
            target=""
            >&rsaquo; Maid Agency Accounting</a
          >

          <a
            class="mb-5 grey--text body-1 d-block text-none"
            href="/accounting-for-startups"
            target=""
            >&rsaquo; Startup Accelarator Program</a
          >
        </base-info-card>
      </div>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseBusinessContact",

  props: {
    dark: Boolean,
    dense: Boolean,
    title: String
  },

  data: () => ({
    business: [
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: "+65-97223997"
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "info@kenwynaccounting.com"
      }
    ]
  })
};
</script>
